import { useMemo } from 'react';
import { FilterValue, getParamsFromFilters } from '../components/common/Filter';

export default (filters: FilterValue[]) => {
  return useMemo(() => getParamsFromFilters(filters), [filters.join('')]);
};
